import { ICourseCertificate, ICreateCourseCertificate } from '@/types/courses';
import { awardEmail } from './email-preview-body';
import Modal from '@ui/modal/modal';
import Container from '@ui/container/container';
import Button from '@ui/buttons/button/button';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';

type Props = {
  certificate: ICourseCertificate | ICreateCourseCertificate;
  open: boolean;
  onRequestClose: () => void;
  channelIcon?: string | null;
  firstName?: string;
  lastName?: string;
  courseName?: string;
  bannerImage?: string | null;
};

export default function EmailPreview(props: Props) {
  const _bannerImage =
    props.bannerImage || 'https://assets.brandlive.com/assets/bl-platform/images/limelight-banner.webp';
  const _channelIcon = props.channelIcon || 'https://assets.brandlive.com/assets/bl-logo-sunset.png';
  const { firstName = 'John', lastName = '', courseName = 'A Course' } = props;

  return (
    <Modal
      open={props.open}
      backgroundColor="var(--gray-900)"
      contentWrapperClassName="radius-12"
      onRequestClose={props.onRequestClose}
      customSize={{
        width: '900px',
        height: '800px',
        minHeight: '300px',
        maxHeight: 'calc(100vh - 80px)',
        maxWidth: 'calc(100vw - 80px)',
      }}
      renderHeaderContent={() => (
        <Container background="var(--gray-900)" className="flex ai-center jc-flex-end padding-16 radius-12">
          <Button onClick={props.onRequestClose}>
            <Icon name={ICONS.CLOSE} size={16} color="var(--gray-600)" />
          </Button>
        </Container>
      )}
    >
      <Container background="var(--gray-900)" className="flex ai-center jc-center">
        <div
          style={{ width: 800, borderRadius: '12px' }}
          dangerouslySetInnerHTML={{
            __html: awardEmail(
              props.certificate.email_body.base,
              _channelIcon,
              _bannerImage,
              firstName,
              lastName,
              courseName,
              'about:blank'
            ),
          }}
        />
      </Container>
    </Modal>
  );
}
